export default __webpack_public_path__ + "static/media/ico-btn.143c096b.svg";